<script lang="ts">
  import DashHero from '../shared/DashHero.svelte';
  import KpiCard from '../widgets/KpiCard.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import DashCard from '../shared/DashCard.svelte';
  import { Optica, Citas } from '../../../lib/api';
  import { tenantCtx } from '../../../lib/tenant.svelte';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();
  const showPlus = $derived(tenantCtx.plan === 'clinica-plus' || tenantCtx.edicion === 'clinic-network');

  let pacientes = $state(0);
  let ordenesActivas = $state(0);
  let enLaboratorio = $state(0);
  let listasEntrega = $state(0);
  let citasHoy = $state(0);
  let stockBajo = $state(0);
  let ordenes = $state<Array<{ paciente: string; estado: string; promesa: string; total: string }>>([]);

  function hoy() { return new Date().toISOString().slice(0, 10); }

  async function cargar() {
    try {
      const [pacs, ords, arts, citas] = await Promise.all([
        Optica.pacientes().catch(() => []),
        Optica.ordenes().catch(() => []),
        Optica.articulos().catch(() => []),
        Citas.listar(hoy()).catch(() => []),
      ]);
      pacientes = pacs.length;
      ordenesActivas = ords.filter(o => o.estado !== 'ENTREGADA' && o.estado !== 'CANCELADA').length;
      enLaboratorio = ords.filter(o => o.estado === 'EN_LABORATORIO').length;
      listasEntrega = ords.filter(o => o.estado === 'LISTA').length;
      citasHoy = citas.length;
      stockBajo = arts.filter(a => (a.stock ?? 0) <= (a.stockMinimo ?? 0)).length;

      const pacMap = new Map(pacs.map(p => [p.id, p.nombre]));
      ordenes = ords.slice(0, 6).map(o => ({
        paciente: pacMap.get(o.pacienteId!) ?? 'Paciente',
        estado: o.estado ?? 'NUEVA',
        promesa: o.fechaPromesa ?? hoy(),
        total: "Q " + Number(o.total ?? 0).toFixed(0),
      }));
    } catch {
    }
  }

  $effect(() => { void cargar(); });

  const actions = [
    { id: 'optica', label: 'Nuevo examen', icon: '👁️' },
    { id: 'expediente', label: 'Expediente CUI', icon: '📋' },
    { id: 'opticaOrdenes', label: 'Orden taller', icon: '🔧' },
    { id: 'opticaInventario', label: 'Inventario', icon: '📦' },
    { id: 'farmaciaPos', label: 'POS', icon: '💊' },
    { id: 'agenda', label: 'Agenda', icon: '📅' },
  ];

  const estadoLabel: Record<string, string> = {
    NUEVA: 'Nueva', EN_LABORATORIO: 'En taller', LISTA: 'Lista entrega', ENTREGADA: 'Entregada',
  };
</script>

<DashHero emoji="" title="Óptica y taller" subtitle="Exámenes, órdenes de lentes e inventario de armazones y micas" variant="optica" showPlus={showPlus} />

<QuickActions {actions} onAction={onNavigate} />

<div class="dash-grid">
  <div class="col-3"><KpiCard label="Pacientes" value={pacientes} hint="Historial optométrico" tone="brand" /></div>
  <div class="col-3"><KpiCard label="Órdenes activas" value={ordenesActivas} hint="{enLaboratorio} en taller" tone="warning" /></div>
  <div class="col-3"><KpiCard label="Listas entrega" value={listasEntrega} hint="Para retiro hoy" tone="success" /></div>
  <div class="col-3"><KpiCard label="Exámenes hoy" value={citasHoy} hint="{stockBajo} artículos bajo mínimo" tone="total" /></div>

  <div class="col-12">
    <DashCard title="Pipeline de taller" hint="Estado de órdenes recientes">
      <table class="pipe-table">
        <thead><tr><th>Paciente</th><th>Estado</th><th>Promesa</th><th>Total</th></tr></thead>
        <tbody>
          {#each ordenes as o}
            <tr>
              <td>{o.paciente}</td>
              <td><span class="pill pill-{o.estado.toLowerCase()}">{estadoLabel[o.estado] ?? o.estado}</span></td>
              <td class="mono">{o.promesa}</td>
              <td class="mono">{o.total}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </DashCard>
  </div>
</div>

<style>
  .pipe-table { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
  .pipe-table th, .pipe-table td { text-align: left; padding: 0.6rem 0.7rem; border-bottom: 1px solid var(--glass-border); }
  .pipe-table th { font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--text-secondary); font-weight: 700; background: rgba(255,255,255,0.3); backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px); }
  .pipe-table tr:hover td { background: rgba(255,255,255,0.35); }
  .mono { font-family: ui-monospace, 'JetBrains Mono', monospace; font-size: 0.8rem; }

  .pill {
    display: inline-block;
    padding: 0.2rem 0.6rem;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
  }
  .pill-nueva { background: rgba(219,234,254,0.6); color: #1e40af; border: 1px solid rgba(59,130,246,0.2); }
  .pill-en_laboratorio { background: rgba(254,243,199,0.6); color: #92400e; border: 1px solid rgba(245,158,11,0.2); }
  .pill-lista { background: rgba(209,250,229,0.6); color: #065f46; border: 1px solid rgba(16,185,129,0.2); }
</style>
